import Margin from "~/components/Margin";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  InputCurrency,
  InputSelect,
  Modal,
  Table,
  Tile,
  Tooltip,
} from "prosperita-dumbo-react";
import "prosperita-dumbo-react/dist/style.css";
import ActivityIcon from "~/assets/Activity.png";
import ActivityBlueIcon from "~/assets/Activity_blue.png";
import lockIcon from "~/assets/lock.png";
import styled from "styled-components";
import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import EditIcon from "~/assets/Edit.png";

import openOperationIcon from "~/assets/side-panel--open.png";

import {
  getCreditProductAPI,
  getCreditProductDetailsAPI,
  ICreditProducts,
  IProductDetails,
} from "~/services/api/creditProduct";
import useOperation from "~/hooks/useOperation";

import {
  getSimulateOperationAPI,
  Installment,
  ISimulateOperationBody,
  ISimulateOperationInstallmentPatch,
  patchSimulateOperationAPI,
  postGenerateExcelAPI,
  postSimulateOperationAPI,
} from "~/services/api/operations";
import {
  convertStringToNumber,
  convertStringCurrencyToNumber,
  formatNumberToCurrencyWithoutSimbol,
} from "~/services/utils";
import AppStorage from "~/services/storage";
import useLoading from "~/hooks/useLoading";
import {
  endOfDay,
  format,
  isAfter,
  isBefore,
  isEqual,
  isPast,
  parseISO,
} from "date-fns";
import { toast } from "react-toastify";
import { getErrorMessage } from "~/services/api/error";
import { Toggle } from "@carbon/react";
// import MoreIcon from "~/assets/Addd.png";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: start;
  padding: 30px 50px;
`;

const TagLup = styled.img`
  object-fit: contain;
  width: 200px;
  margin: 20px 0;
`;

const Text = styled.h4`
  color: #161616;
  font-family: "IBM Plex Sans";
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 20px;
`;

const Subtext = styled.h4`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 20px;
`;

type Values = {
  nickname: string;
  product_uuid: string;
  calculation_type: string;
  requested_amount: string;
  duration: string;
  calculation_base: string;
  operation_date: string;
  release_date: string;
  due_date: string;
  interest_rate_monthly: string;
  interest_periodicity: string;
  amortization_grace_period: string;
  interest_grace_period: string;
  commission: string;
  birthday_date_type: string;
  birthday_date_day: string;
  indexer: string;
  indexer_rate: string;
  amortization_amount: string | number;
  due_date_installment: string;
  interest: string | number;
  unit_amount: string;
  number: number;
  outstanding_amount: string | number;
  pmt: string | number;
  interest_enabled: boolean;
  original_interest: string | number;
};

const initialValues: Values = {
  nickname: "",
  product_uuid: "",
  calculation_type: "",
  requested_amount: "10.000,00",
  duration: "",
  calculation_base: "",
  operation_date: "",
  release_date: "",
  due_date: "",
  birthday_date_day: "1",
  birthday_date_type: "",
  interest_rate_monthly: "0",
  interest_periodicity: "",
  amortization_grace_period: "0",
  interest_grace_period: "0",
  commission: "",
  unit_amount: "1.000,00",
  indexer: "",
  indexer_rate: "100",
  amortization_amount: 0,
  due_date_installment: "",
  interest: "",
  number: 0,
  outstanding_amount: "",
  pmt: "",
  interest_enabled: true,
  original_interest: "",
};

const SimulationCommercialNote = () => {
  const navigate = useNavigate();

  const {
    setPayloadSimulateOperation,
    setSimulateResult,
    simulateResult,
    setCreditProducts,
    creditProducts,
    editInstallment,
    setEditInstallment,
    installmentData,
    setInstallmentData,
  } = useOperation();

  const [previousInstallment, setPreviousInstallment] =
    useState<Installment | null>(null);
  const [isExporting, setIsExporting] = useState(false);

  const { setLoading } = useLoading();

  const { values, setFieldValue } = useFormik({
    initialValues,
    onSubmit: () => undefined,
  });

  const handleSelect = (fieldName, selectedOption) => {
    if (selectedOption) {
      setFieldValue(fieldName, selectedOption.value);
    }
  };

  const titlesColumnInstallments = [
    "Parcela",
    "Data",
    "Valor nominal",
    "Juros + indexador",
    "Amortização",
    "Preço unitário",
    "",
  ];

  const dataTableInstallments = simulateResult?.installments.map(
    (installment, index) => {
      const isFirstInstallment = index === 0;
      const previousInstallmentData =
        index > 0 ? simulateResult?.installments[index - 1] : null;
      return {
        Parcela: installment.number,
        Data: format(parseISO(installment.due_date), "dd/MM/yyyy"),
        "Valor nominal": `R$ ${formatNumberToCurrencyWithoutSimbol(
          installment.outstanding_amount
        )}`,
        "Juros + indexador": `R$ ${formatNumberToCurrencyWithoutSimbol(installment.interest)}`,
        Amortização: `R$ ${formatNumberToCurrencyWithoutSimbol(
          installment.amortization_amount
        )}`,
        "Preço unitário": `R$ ${formatNumberToCurrencyWithoutSimbol(installment.pmt)}`,
        "": isFirstInstallment ? null : (
          <div
            style={{
              display: "flex",
              position: "relative",
              left: "-60px",
              height: "8px",
            }}
          >
            <Tooltip
              align={
                simulateResult.product.amortization_type === "sac"
                  ? "top-right"
                  : "top-right"
              }
              size="large"
              label={
                simulateResult.product.amortization_type !== "sac"
                  ? "Não é possivel editar parcelas quando a amortização não é do tipo SAC"
                  : "Editar parcela"
              }
            >
              <Button
                kind="ghost"
                size="small"
                icon={EditIcon}
                // disabled={simulateResult.product.amortization_type !== "sac"}
                onClick={() => {
                  setFieldValue(
                    "interest",
                    formatNumberToCurrencyWithoutSimbol(installment.interest)
                  );
                  setFieldValue(
                    "amortization_amount",
                    formatNumberToCurrencyWithoutSimbol(
                      installment.amortization_amount
                    )
                  );
                  setFieldValue("due_date_installment", installment.due_date);
                  setPreviousInstallment(previousInstallmentData);
                  setInstallmentData(installment);
                  setEditInstallment(true);
                }}
              />
            </Tooltip>
          </div>
        ),
      };
    }
  );

  const canDoSimulations = true;

  const indexesOptions = useMemo(() => {
    return [
      { index: "SELIC", value: "selic" },
      { index: "IGPM", value: "igpm" },
      { index: "IPCA", value: "ipca" },
      { index: "CDI", value: "cdi" },
      { index: "Nenhum", value: "no_one" },
    ].map((index) => ({
      value: index.value,
      label: index.index,
    }));
  }, []);

  const birthDateOptions = useMemo(() => {
    return [
      { index: "Pagamento", value: "payment" },
      { index: "Fixa", value: "fixed" },
    ].map((index) => ({
      value: index.value,
      label: index.index,
    }));
  }, []);

  const calculationBaseOptions = useMemo(() => {
    return [
      { value: "net_value", label: "Valor Líquido" },
      { value: "gross_value", label: "Valor Bruto" },
    ].sort((a, b) =>
      a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
    );
  }, []);

  const periodicityOptions = useMemo(() => {
    return [
      { label: "Diário", value: "daily" },
      { label: "Mensal", value: "monthly" },
      { label: "Anual", value: "annually" },
    ]
      .map((periodicity) => ({
        value: periodicity.value,
        label: periodicity.label,
      }))

      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, []);

  const creditProductsOptions = useMemo(() => {
    return creditProducts
      .filter(
        (creditProduct: ICreditProducts) =>
          creditProduct?.product_type === "commercial_note"
      )
      .map((creditProduct: ICreditProducts) => ({
        value: creditProduct.uuid,
        label: creditProduct.name,
      }))

      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, [creditProducts]);

  const calculationTypeOptions = useMemo(() => {
    return [
      { value: "360", label: "360 Dias" },
      { value: "365", label: "365 Dias" },
      { value: "252", label: "252 Dias" },
    ]
      .map((type) => ({
        value: type.value,
        label: type.label,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" })
      );
  }, []);

  const indexesDict: { [key: string]: string } = {
    igpm: "IGPM",
    selic: "SELIC",
    ipca: "IPCA",
    cdi: "CDI",
    no_one: "Nenhum",
  };

  const payloadSimulateOperation: ISimulateOperationBody = useMemo(() => {
    const taxesSettings: ISimulateOperationBody["taxes_settings"] = {
      interest_rate: values.interest_rate_monthly?.includes(",")
        ? convertStringToNumber(values.interest_rate_monthly)
        : Number(values.interest_rate_monthly),
      interest_periodicity: values.interest_periodicity,
      amortization_grace_period: Number(values.amortization_grace_period),
      interest_grace_period: Number(values.interest_grace_period),
      commission: values.commission?.includes(",")
        ? convertStringToNumber(values.commission)
        : Number(values.commission),
      ...(values.indexer !== "no_one"
        ? {
            indexer: values.indexer,
            indexer_rate: values.indexer_rate?.includes(",")
              ? convertStringToNumber(values.indexer_rate)
              : Number(values.indexer_rate),
          }
        : {}),
    };

    const payload: ISimulateOperationBody = {
      nickname: values.nickname,
      product_uuid: values.product_uuid,
      calculation_type: values.calculation_type,
      requested_amount: convertStringToNumber(values.requested_amount),
      unit_amount: convertStringToNumber(values.unit_amount),
      duration: Number(values.duration),
      calculation_base: values.calculation_base,
      release_date: values.release_date,
      due_date: values.due_date,
      taxes_settings: taxesSettings,
    };

    if (values.birthday_date_type) {
      payload.birthday_date_type = values.birthday_date_type;
    }

    if (values.birthday_date_type === "fixed") {
      payload.birthday_date_day = Number(values.birthday_date_day);
    }

    return payload;
  }, [values]);

  const sendNewSimulate = useCallback(async (): Promise<void> => {
    setLoading(true);
    setSimulateResult(null);
    try {
      const payloadSimulateOperation = AppStorage.get(
        "@:simulate_operation"
      ) as string;
      const payloadSimulateOperationParsed = JSON.parse(
        payloadSimulateOperation
      );

      const { data } = await postSimulateOperationAPI(
        payloadSimulateOperationParsed
      );
      setSimulateResult(data.payload);

      toast.success("Simulação gerada com sucesso!");

      setLoading(false);
    } catch (e) {
      console.log(e);
      toast.error(getErrorMessage(e, "Não foi possível gerar a simulação !"));

      setLoading(false);
    }
  }, [setSimulateResult, setLoading]);

  const fetchCreditProducts = useCallback(async () => {
    try {
      const { data } = await getCreditProductAPI();
      setCreditProducts(data.payload);
    } catch (e) {
      console.log(e);
    }
  }, [setCreditProducts]);

  // Função para fechar modal após salvar com sucesso
  const handleCloseModalAfterSave = () => {
    setEditInstallment(false);
  };

  const sendUpdateInstallment = useCallback(async () => {
    if (simulateResult && installmentData) {
      setLoading(true);
      const payload: ISimulateOperationInstallmentPatch = {
        installment_number: installmentData.number,
      };

      const amortizationAmount = convertStringCurrencyToNumber(
        values.amortization_amount as string
      );
      if (
        amortizationAmount !== installmentData.amortization_amount ||
        (amortizationAmount === 0 && installmentData.amortization_amount !== 0)
      ) {
        payload.amortization = amortizationAmount;
      }

      const interestAmount = convertStringCurrencyToNumber(
        values.interest as string
      );
      if (
        interestAmount !== installmentData.interest ||
        (interestAmount === 0 && installmentData.interest !== 0)
      ) {
        payload.interest = interestAmount;
      }

      if (values.due_date_installment !== installmentData.due_date) {
        payload.due_date = values.due_date_installment;
      }

      if (Object.keys(payload).length > 1) {
        try {
          const { data } = await patchSimulateOperationAPI(
            simulateResult.uuid,
            payload
          );

          setLoading(false);
          handleCloseModalAfterSave();
          setSimulateResult(data.payload);
          toast.success("Parcela atualizada com sucesso!");
        } catch (e) {
          console.log(e);
          setLoading(false);
          toast.error(getErrorMessage(e, "Não foi possível alterar a parcela!"));
        }
      } else {
        setLoading(false);
        handleCloseModalAfterSave();
      }
    }
  }, [
    simulateResult,
    installmentData,
    setLoading,
    values,
    setEditInstallment,
    setSimulateResult,
    handleCloseModalAfterSave,
  ]);

  const fetchSimulation = useCallback(async () => {
    setLoading(true);
    localStorage.removeItem("@:involveds");
    localStorage.removeItem("@:simulate_operation");
    localStorage.removeItem("@:operation");
    localStorage.removeItem("@:simulation_uuid");
    localStorage.removeItem("@:documents");

    try {
      if (simulateResult?.uuid) {
        const { data } = await getSimulateOperationAPI(simulateResult?.uuid);

        const simulation = data.payload;
        setSimulateResult(null);
        localStorage.setItem(
          "@:simulation_uuid",
          JSON.stringify({ simulation_uuid: simulateResult?.uuid })
        );

        const payload = {
          nickname: simulation.nickname,
          product_uuid: simulation.product.uuid,
          calculation_type: simulation.calculation_type,
          requested_amount: simulation.requested_amount,
          duration: Number(simulation.duration),
          calculation_base: simulation.calculation_base,
          release_date: simulation.release_date,
          due_date: simulation.due_date,
          bithday_date_type: simulation.birthday_date_type,
          birthday_date_day: Number(simulation.birthday_date_day),
          unit_amount: simulation.unit_amount,
          taxes_settings: {
            interest_rate_monthly:
              simulation.taxes_settings.interest_rate_monthly,
            interest_rate: simulation.taxes_settings.interest_rate_monthly,
            interest_periodicity:
              simulation.taxes_settings.interest_periodicity,
            amortization_grace_period:
              simulation.taxes_settings.amortization_grace_period,
            interest_grace_period:
              simulation.taxes_settings.interest_grace_period,
            commission: simulation.taxes_settings.commission,
            indexer: simulation.taxes_settings.indexer,
            indexer_rate: simulation.taxes_settings.indexer_rate,
          },
        };

        localStorage.setItem("@:simulate_operation", JSON.stringify(payload));

        navigate("/app/credit/operations/new/commercial-note/product-info");
        setSimulateResult(null);

        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      toast.error(getErrorMessage(e, "Não foi possível recuperar a simulação !"));
      setLoading(false);
    }
  }, [navigate, setLoading, setSimulateResult, simulateResult?.uuid]);

  const printRef = useRef<HTMLDivElement>(null);

  const isNotDivisible = useMemo(() => {
    const requested = convertStringCurrencyToNumber(values.requested_amount);
    const unit = convertStringCurrencyToNumber(values.unit_amount);

    if (unit === 0) return true;
    return !Number.isInteger(requested / unit);
  }, [values.requested_amount, values.unit_amount]);

  const [errorDueDateInstallment, setErrorDueDateInstallment] =
    useState<boolean>(false);
  const [errorDueDateToLongInstallment, setErrorDueDateToLongInstallment] =
    useState<boolean>(false);
  const [
    errorAmortizationInstallmentAmount,
    setErrorAmortizationInstallmentAmount,
  ] = useState<boolean>(false);
  const [errorInterestAmountInstallment, setErrorInterestAmountInstallment] =
    useState<boolean>(false);

  useEffect(() => {
    const currentDueDate = parseISO(values.due_date_installment);

    if (previousInstallment) {
      const previousInstallmentDueDate = parseISO(previousInstallment.due_date);

      if (isBefore(currentDueDate, previousInstallmentDueDate)) {
        setErrorDueDateInstallment(true);
      } else {
        setErrorDueDateInstallment(false);
      }

      if (
        simulateResult?.due_date &&
        (isAfter(currentDueDate, parseISO(simulateResult?.due_date)) ||
          isEqual(currentDueDate, parseISO(simulateResult?.due_date)))
      ) {
        setErrorDueDateToLongInstallment(true);
      } else {
        setErrorDueDateToLongInstallment(false);
      }

      const currentAmortizationAmount = convertStringCurrencyToNumber(
        values.amortization_amount
      );
      const previousInstallmentOutstandingAmount = Number(
        previousInstallment?.outstanding_amount || 0
      );

      if (
        currentAmortizationAmount < 0 ||
        currentAmortizationAmount > previousInstallmentOutstandingAmount
      ) {
        setErrorAmortizationInstallmentAmount(true);
      } else {
        setErrorAmortizationInstallmentAmount(false);
      }

      const currentInterestAmortizationAmount = convertStringCurrencyToNumber(
        values.interest || 0
      );
      const currentInterestAmount = Number(installmentData?.interest || 0);

      if (
        currentInterestAmortizationAmount < 0 ||
        currentInterestAmortizationAmount > currentInterestAmount
      ) {
        setErrorInterestAmountInstallment(true);
      } else {
        setErrorInterestAmountInstallment(false);
      }
    }
  }, [values, previousInstallment, installmentData, simulateResult?.due_date]);

  useEffect(() => {
    fetchCreditProducts();
  }, [fetchCreditProducts]);

  useEffect(() => {
    if (installmentData) {
      setFieldValue("outstanding_amount", installmentData.outstanding_amount);
      setFieldValue("due_date_installment", installmentData.due_date);
      setFieldValue("pmt", String(installmentData.pmt));
      
      const formattedInterest = formatNumberToCurrencyWithoutSimbol(installmentData.interest);
      setFieldValue("original_interest", formattedInterest);
      
      // Define se os juros estão ativados baseado no valor original
      const hasInterest = convertStringCurrencyToNumber(formattedInterest) > 0;
      setFieldValue("interest_enabled", hasInterest);
      
      // Se há juros, sempre ativar o toggle e mostrar o valor original
      if (hasInterest) {
        setFieldValue("interest", formattedInterest);
      } else {
        setFieldValue("interest", "0,00");
      }
      
      setFieldValue(
        "amortization_amount",
        formatNumberToCurrencyWithoutSimbol(installmentData.amortization_amount)
      );
    }
  }, [installmentData, setFieldValue]);

  useEffect(() => {
    setPayloadSimulateOperation(payloadSimulateOperation);
    localStorage.setItem(
      "@:simulate_operation",
      JSON.stringify(payloadSimulateOperation)
    );
  }, [payloadSimulateOperation, setPayloadSimulateOperation]);

  // Controla o valor dos juros baseado no toggle
  useEffect(() => {
    if (values.interest_enabled) {
      setFieldValue("interest", values.original_interest);
    } else {
      setFieldValue("interest", "0,00");
    }
  }, [values.interest_enabled, values.original_interest, setFieldValue]);

  const [productDetails, setProductDetails] = useState<IProductDetails>();

  // Função para fechar modal e restaurar valores originais
  const handleCloseModal = () => {
    // Restaurar valores originais da API se houver dados da parcela
    if (installmentData) {
      const formattedInterest = formatNumberToCurrencyWithoutSimbol(installmentData.interest);
      const hasInterest = convertStringCurrencyToNumber(formattedInterest) > 0;
      
      setFieldValue("interest", formattedInterest);
      setFieldValue("original_interest", formattedInterest);
      setFieldValue("interest_enabled", hasInterest);
      setFieldValue("amortization_amount", formatNumberToCurrencyWithoutSimbol(installmentData.amortization_amount));
      setFieldValue("due_date_installment", installmentData.due_date);
      setFieldValue("outstanding_amount", installmentData.outstanding_amount);
      setFieldValue("pmt", String(installmentData.pmt));
    }
    
    setEditInstallment(false);
  };

  const fetchProductDetails = useCallback(async (uuid: string) => {
    try {
      const { data } = await getCreditProductDetailsAPI(uuid);
      setProductDetails(data.payload);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    if (values.product_uuid) {
      fetchProductDetails(values.product_uuid);
    }
  }, [values.product_uuid, fetchProductDetails]);

  const [errorInterestRate, setErrorInterestRate] = useState<boolean>(false);
  const [errorAmortizationPeriod, setErrorAmortizationPeriod] =
    useState<boolean>(false);
  const [errorCommission, setErrorCommission] = useState<boolean>(false);
  const [errorPrincipalAmount, setErrorPrincipalAmount] =
    useState<boolean>(false);

  const [errorDuration, setErrorDuration] = useState<boolean>(false);

  const [errorReleaseDate, setErrorReleaseDate] = useState<boolean>(false);
  const [errorDueDate, setErrorDueDate] = useState<boolean>(false);

  useEffect(() => {
    const interestRate = values.interest_rate_monthly?.includes(",")
      ? convertStringToNumber(values.interest_rate_monthly)
      : Number(values.interest_rate_monthly);

    const commissionRate = values.commission?.includes(",")
      ? convertStringToNumber(values.commission)
      : Number(values.commission);

    const parsedReleaseDate = parseISO(values.release_date);
    const parsedDueDate = parseISO(values.due_date);

    if (productDetails) {
      if (
        interestRate < productDetails?.min_interest_rate ||
        interestRate > productDetails?.max_interest_rate
      ) {
        setErrorInterestRate(true);
      } else {
        setErrorInterestRate(false);
      }

      if (
        Number(values.amortization_grace_period) <
          productDetails?.min_amortization_period ||
        Number(values.amortization_grace_period) >
          productDetails?.max_amortization_period
      ) {
        setErrorAmortizationPeriod(true);
      } else {
        setErrorAmortizationPeriod(false);
      }

      if (
        convertStringToNumber(values.requested_amount) >
          productDetails.max_principal_amount ||
        convertStringToNumber(values.requested_amount) <
          productDetails.min_principal_amount
      ) {
        setErrorPrincipalAmount(true);
      } else {
        setErrorPrincipalAmount(false);
      }
    }

    if (Number(values.duration) < 1) {
      setErrorDuration(true);
    } else {
      setErrorDuration(false);
    }
    if (commissionRate < 0 || commissionRate > 100) {
      setErrorCommission(true);
    } else {
      setErrorCommission(false);
    }

    if (values.release_date && isPast(endOfDay(parsedReleaseDate))) {
      setErrorReleaseDate(true);
    } else {
      setErrorReleaseDate(false);
    }

    if (values.release_date && values.due_date) {
      if (isBefore(parsedDueDate, parsedReleaseDate) || isEqual(parsedDueDate, parsedReleaseDate)) {
        setErrorDueDate(true);
      } else {
        setErrorDueDate(false);
      }
    } else if (values.due_date && !values.release_date) {
      // Se só a data de vencimento está preenchida, não valida ainda
      setErrorDueDate(false);
    } else {
      setErrorDueDate(false);
    }
  }, [
    values.interest_rate_monthly,
    values.amortization_grace_period,
    values.commission,
    productDetails,
    values.requested_amount,
    values.duration,
    values.release_date,
    values.due_date,
  ]);

  useEffect(() => {
    if (values.indexer === "no_one") {
      setFieldValue("indexer_rate", "0");
    } else if (values.indexer !== "no_one" && values.indexer_rate === "0") {
      setFieldValue("indexer_rate", "100");
    }
  }, [values, setFieldValue]);

  useEffect(() => {
    if (productDetails) {
      setFieldValue(
        "interest_rate_monthly",
        productDetails?.min_interest_rate !== undefined &&
          String(productDetails?.min_interest_rate)
      );

      setFieldValue(
        "amortization_grace_period",
        productDetails?.min_amortization_period !== undefined &&
          String(productDetails?.min_amortization_period)
      );

      setFieldValue(
        "interest_grace_period",
        productDetails?.min_amortization_period !== undefined &&
          String(productDetails?.min_amortization_period)
      );
    }
    setFieldValue("duration", "1");
    setFieldValue("commission", "0");
  }, [productDetails, setFieldValue]);

  const [errorBirthdayDate, setErrorBirthdayDate] = useState(false);

  useEffect(() => {
    if (values.indexer !== "igpm" && values.indexer !== "ipca") {
      setFieldValue("birthday_date_type", "");
      setFieldValue("birthday_date_day", "1");
    }

    if (values.birthday_date_type !== "fixed") {
      setFieldValue("birthday_date_day", "1");
    }

    if (
      ((values.indexer === "igpm" || values.indexer === "ipca") &&
        values.birthday_date_type === "") ||
      ((values.indexer === "igpm" || values.indexer === "ipca") &&
        values.birthday_date_type === "fixed" &&
        (values.birthday_date_day === "0" || values.birthday_date_day === ""))
    ) {
      setErrorBirthdayDate(true);
    } else {
      setErrorBirthdayDate(false);
    }
  }, [values, setFieldValue]);

  useEffect(() => {
    setSimulateResult(null);
  }, [setSimulateResult]);

  const [showRequiredErrors, setShowRequiredErrors] = useState(false);

  const hasFormErrors = useMemo(() => {
    return (
      !values.release_date ||
      isNotDivisible ||
      convertStringCurrencyToNumber(values.unit_amount) < 1 ||
      convertStringCurrencyToNumber(values.unit_amount) >
        convertStringCurrencyToNumber(values.requested_amount) ||
      convertStringCurrencyToNumber(values.requested_amount) <
        convertStringCurrencyToNumber(values.unit_amount) ||
      !values.amortization_grace_period ||
      !values.calculation_base ||
      !values.calculation_type ||
      !values.product_uuid ||
      errorDueDate ||
      !values.due_date ||
      errorBirthdayDate ||
      !values.commission ||
      !values.duration ||
      !values.indexer ||
      (values.indexer !== "no_one" && Number(values.indexer_rate) < 1) ||
      !values.interest_grace_period ||
      !values.interest_periodicity ||
      !values.interest_rate_monthly ||
      !values.nickname ||
      errorAmortizationPeriod ||
      errorCommission ||
      errorDuration ||
      errorInterestRate ||
      errorPrincipalAmount ||
      errorReleaseDate ||
      (values.indexer === "selic" && values.calculation_type !== "252") ||
      (values.indexer === "cdi" && values.calculation_type !== "252")
    );
  }, [
    values,
    isNotDivisible,
    errorDueDate,
    errorBirthdayDate,
    errorAmortizationPeriod,
    errorCommission,
    errorDuration,
    errorInterestRate,
    errorPrincipalAmount,
    errorReleaseDate,
  ]);

  const getFirstErrorFieldId = (): string | null => {
    if (!values.nickname) return "nickname";
    if (!values.product_uuid) return "product_uuid";
    if (!values.calculation_type) return "calculation_type";

    const requestedAmount = convertStringToNumber(values.requested_amount);
    const unitAmount = convertStringCurrencyToNumber(values.unit_amount);

    if (
      !values.requested_amount ||
      errorPrincipalAmount ||
      isNotDivisible ||
      requestedAmount < unitAmount
    ) {
      return "requested_amount";
    }

    if (
      !values.unit_amount ||
      unitAmount < 1 ||
      unitAmount > convertStringCurrencyToNumber(values.requested_amount)
    ) {
      return "unit_amount";
    }

    if (!values.duration || errorDuration) return "duration";
    if (!values.release_date || errorReleaseDate) return "release_date";
    if (!values.due_date || errorDueDate) return "due_date";
    if (!values.interest_rate_monthly || errorInterestRate)
      return "interest_rate_monthly";
    if (!values.interest_periodicity) return "interest_periodicity";
    if (
      !values.amortization_grace_period ||
      errorAmortizationPeriod ||
      (values.amortization_grace_period &&
        values.duration &&
        Number(values.amortization_grace_period) >= Number(values.duration))
    )
      return "amortization_grace_period";

    if (
      !values.interest_grace_period ||
      (values.interest_grace_period &&
        values.duration &&
        Number(values.interest_grace_period) >= Number(values.duration)) ||
      (values.interest_grace_period &&
        values.amortization_grace_period &&
        Number(values.interest_grace_period) >
          Number(values.amortization_grace_period))
    )
      return "interest_grace_period";

    if (!values.calculation_base) return "calculation_base";

    if (!values.commission || errorCommission) return "commission";

    if (!values.indexer) return "indexer";

    if (values.indexer !== "no_one" && Number(values.indexer_rate) < 1)
      return "indexer_rate";

    if (
      (values.indexer === "igpm" || values.indexer === "ipca") &&
      (!values.birthday_date_type ||
        (values.birthday_date_type === "fixed" &&
          (!values.birthday_date_day ||
            values.birthday_date_day === "0")))
    ) {
      return values.birthday_date_type === "fixed"
        ? "birthday_date_day"
        : "birthday_date_type";
    }

    if (
      values.indexer === "selic" &&
      values.calculation_type &&
      values.calculation_type !== "252"
    )
      return "calculation_type";

    if (
      values.indexer === "cdi" &&
      values.calculation_type &&
      values.calculation_type !== "252"
    )
      return "calculation_type";

    return null;
  };

  const handleSimulateClick = () => {
    setShowRequiredErrors(true);

    if (hasFormErrors) {
      const fieldId = getFirstErrorFieldId();
      if (fieldId) {
        const element = document.getElementById(fieldId);
        if (element) {
          (element as HTMLElement).focus();
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
      return;
    }

    sendNewSimulate();
  };

  const handleGenerateExcel = useCallback(async () => {
    if (!simulateResult?.uuid) {
      toast.error("UUID da simulação não encontrado!");
      return;
    }

    // Prevenir múltiplas chamadas simultâneas
    if (isExporting) {
      return;
    }

    try {
      setIsExporting(true);
      setLoading(true);
      const { data } = await postGenerateExcelAPI({
        operation_uuid: simulateResult.uuid,
      });
      const payload = data.payload;

      // Criar um link temporário e fazer o download do arquivo
      const link = document.createElement("a");
      link.href = payload.url;
      link.download = payload.filename.split("/").pop() || "simulacao.xlsx";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setLoading(false);
      setIsExporting(false);
      toast.success("Simulação exportada com sucesso!");
    } catch (e) {
      console.log(e);
      setLoading(false);
      setIsExporting(false);
      toast.error("Não foi possível exportar a simulação!");
    }
  }, [simulateResult?.uuid, setLoading, isExporting]);

  return (
    <Container>
      <Breadcrumb
        crumbsOptions={[
          {
            crumb: "Simulações",
            onClick: () => navigate("/app/credit/simulations"),
          },
          { crumb: "Nova simulação (Nota Comercial)" },
        ]}
        endHiddenIndex={5}
        startHiddenIndex={5}
      />

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        ></div>
      </div>
      <div style={{ width: "100%" }}>
        <>
          {canDoSimulations && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <Margin mb={30} />
                  <Text style={{ fontSize: "25px" }}>
                    Simulação Nota Comercial{" "}
                    {simulateResult?.uuid && `- ID: ${simulateResult.uuid}`}
                  </Text>
                  <Margin mb={20} />
                  <h4>Parâmetros da operação</h4>
                </div>

                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  {simulateResult?.nickname && (
                    <Tooltip
                      align="left"
                      size="small"
                      label={"Exportar Simulação (.xlsx)"}
                      width="150px"
                    >
                      <Button
                        size="large"
                        kind="secondary"
                        onClick={handleGenerateExcel}
                        disabled={isExporting}
                        icon={
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              fillOpacity="0.01"
                            />
                            <path
                              d="M13 12V14H3V12H2V14L2.0038 13.9976C2.00333 14.1288 2.02873 14.2589 2.07854 14.3803C2.12836 14.5017 2.20163 14.6121 2.29414 14.7052C2.38666 14.7983 2.49662 14.8723 2.61774 14.9229C2.73885 14.9734 2.86875 14.9997 3 15H13C13.2652 15 13.5196 14.8946 13.7071 14.7071C13.8946 14.5196 14 14.2652 14 14V12H13Z"
                              fill={"#fff"}
                            />
                            <path
                              d="M3 6L3.7055 6.7025L7.5 2.9125V12H8.5V2.9125L12.2955 6.7025L13 6L8 1L3 6Z"
                              fill={"#fff"}
                            />
                          </svg>
                        }
                        hasIconSvg
                      />
                    </Tooltip>
                  )}
                  <Button
                    kind={simulateResult?.nickname ? "tertiary" : "primary"}
                    label="Simular"
                    size="large"
                    icon={
                      simulateResult?.nickname ? ActivityBlueIcon : ActivityIcon
                    }
                    onClick={handleSimulateClick}
                  />
                  {simulateResult?.nickname && (
                    <Button
                      kind={"primary"}
                      label="Abrir operação"
                      size="large"
                      icon={openOperationIcon}
                      onClick={() => fetchSimulation()}
                    />
                  )}
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  gap: "32px",
                  rowGap: "30px",
                  marginTop: "20px",
                }}
              >
                <div>
                  {" "}
                  <Input
                    name="nickname"
                    id="nickname"
                    value={values.nickname}
                    size="large"
                    label="Nome (Apelido)"
                    placeholder="Digite"
                    error={showRequiredErrors && !values.nickname}
                    message={
                      showRequiredErrors && !values.nickname
                        ? "Campo obrigatório"
                        : ""
                    }
                    onChange={(e) => setFieldValue("nickname", e.target.value)}
                  />
                </div>
                <div>
                  {" "}
                  <InputSelect
                    name="product_uuid"
                    id="product_uuid"
                    kind="default"
                    size="small"
                    label="Produto"
                    options={creditProductsOptions}
                    placeholder="Selecione uma opção"
                    error={showRequiredErrors && !values.product_uuid}
                    message={
                      showRequiredErrors && !values.product_uuid
                        ? "Campo obrigatório"
                        : ""
                    }
                    onChange={(e) => handleSelect("product_uuid", e)}
                  />
                </div>
                <div>
                  <InputSelect
                    name="calculation_type"
                    id="calculation_type"
                    kind="default"
                    size="small"
                    label="Tipo de cálculo"
                    options={calculationTypeOptions}
                    placeholder="Selecione uma opção"
                    onChange={(e) => handleSelect("calculation_type", e)}
                    error={
                      (showRequiredErrors && !values.calculation_type) ||
                      (values.calculation_type !== "252" &&
                        (values.indexer === "cdi" || values.indexer === "selic"))
                    }
                    message={
                      showRequiredErrors && !values.calculation_type
                        ? "Campo obrigatório"
                        : values.indexer === "cdi" &&
                            values.calculation_type !== "252"
                          ? "Para o indexador pós-fixado 'CDI' mude o tipo de calculo para 252 dias "
                          : values.indexer === "selic" &&
                              values.calculation_type !== "252"
                            ? "Para o indexador pós-fixado 'SELIC' mude o tipo de calculo para 252 dias "
                            : ""
                    }
                  />
                </div>
                <div>
                  <InputCurrency
                    name="requested_amount"
                    id="requested_amount"
                    size="large"
                    label="Valor solicitado (R$)"
                    max={22}
                    maxLength={22}
                    placeholder="R$"
                    error={
                      errorPrincipalAmount ||
                      isNotDivisible ||
                      convertStringToNumber(values.requested_amount) <
                        convertStringCurrencyToNumber(values.unit_amount)
                    }
                    message={
                      showRequiredErrors && !values.requested_amount
                        ? "Campo obrigatório"
                        : productDetails && errorPrincipalAmount
                          ? ` Digite um valor entre R$ ${formatNumberToCurrencyWithoutSimbol(productDetails.min_principal_amount)} e R$ ${formatNumberToCurrencyWithoutSimbol(productDetails.max_principal_amount)}`
                          : convertStringToNumber(values.requested_amount) <
                              convertStringCurrencyToNumber(values.unit_amount)
                            ? "O valor solicitado deve ser maior ou igual ao preço unitário"
                            : isNotDivisible &&
                                convertStringToNumber(values.requested_amount) >
                                  convertStringCurrencyToNumber(
                                    values.unit_amount
                                  )
                              ? "O valor solicitado precisa ser divisível pelo preço unitário"
                              : ""
                    }
                    value={values.requested_amount}
                    onChange={(e) =>
                      setFieldValue("requested_amount", e.target.value)
                    }
                  />
                </div>
                <div>
                  <InputCurrency
                    name="unit_amount"
                    id="unit_amount"
                    max={22}
                    maxLength={22}
                    size="large"
                    label="Preço unitário (R$)"
                    placeholder="R$"
                    error={
                      convertStringCurrencyToNumber(values.unit_amount) < 1 ||
                      convertStringCurrencyToNumber(values.unit_amount) >
                        convertStringCurrencyToNumber(values.requested_amount)
                    }
                    message={
                      showRequiredErrors && !values.unit_amount
                        ? "Campo obrigatório"
                        : convertStringCurrencyToNumber(values.unit_amount) < 1 ||
                            convertStringCurrencyToNumber(values.unit_amount) >
                              convertStringCurrencyToNumber(
                                values.requested_amount
                              )
                          ? ` Digite um valor entre R$ 1,00 e R$ ${formatNumberToCurrencyWithoutSimbol(convertStringCurrencyToNumber(values.requested_amount))}`
                          : ""
                    }
                    value={values.unit_amount}
                    onChange={(e) =>
                      setFieldValue("unit_amount", e.target.value)
                    }
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <Input
                    name="duration"
                    id="duration"
                    maxLength={5}
                    max={5}
                    error={errorDuration}
                    size="large"
                    label="Quantidade de amortizações"
                    value={values.duration}
                    placeholder="Digite"
                    message={
                      showRequiredErrors && !values.duration
                        ? "Campo obrigatório"
                        : errorDuration
                          ? "Digite um valor maior que 0"
                          : ""
                    }
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/[^0-9]/g, "");
                      setFieldValue("duration", value);
                    }}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <Tooltip
                    align="top"
                    size="medium"
                    label="Data simulada da primeira subscrição"
                  >
                    {" "}
                    <Input
                      type="date"
                      name="release_date"
                      id="release_date"
                      size="large"
                      label="Data de lançamento"
                      placeholder="Digite"
                    error={
                      (showRequiredErrors && !values.release_date) ||
                      errorReleaseDate
                    }
                      message={
                        showRequiredErrors && !values.release_date
                          ? "Campo obrigatório"
                          : errorReleaseDate
                            ? "A data de lançamento precisa ser igual ou posterior a data atual"
                            : ""
                      }
                      value={values.release_date}
                      onChange={(e) =>
                        setFieldValue("release_date", e.target.value)
                      }
                    />
                  </Tooltip>
                </div>
                <div>
                  <Input
                    name="due_date"
                    id="due_date"
                    size="large"
                    type="date"
                    label="Data de vencimento"
                    value={values.due_date}
                    error={
                      (showRequiredErrors && !values.due_date) || errorDueDate
                    }
                    message={
                      showRequiredErrors && !values.due_date
                        ? "Campo obrigatório"
                        : errorDueDate
                          ? "A data de vencimento precisa ser posterior a data de lançamento"
                          : ""
                    }
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      setFieldValue("due_date", inputValue);
                    }}
                  />
                </div>

                <div style={{ position: "relative", top: "3px" }}>
                  <Input
                    name="interest_rate_monthly"
                    id="interest_rate_monthly"
                    maxLength={6}
                    max={6}
                    size="large"
                    label="Taxa de juros (%)"
                    placeholder="%"
                    message={
                      showRequiredErrors && !values.interest_rate_monthly
                        ? "Campo obrigatório"
                        : errorInterestRate
                          ? `Informe um valor entre ${productDetails?.min_interest_rate}% e ${productDetails?.max_interest_rate}%`
                          : ""
                    }
                    error={
                      (showRequiredErrors && !values.interest_rate_monthly) ||
                      errorInterestRate
                    }
                    value={values.interest_rate_monthly}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d.]/g, "");
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        return;
                      }

                      setFieldValue("interest_rate_monthly", value);
                    }}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <InputSelect
                    name="interest_periodicity"
                    id="interest_periodicity"
                    kind="default"
                    size="small"
                    label="Periodicidade dos juros"
                    options={periodicityOptions}
                    placeholder="Selecione uma opção"
                    error={showRequiredErrors && !values.interest_periodicity}
                    message={
                      showRequiredErrors && !values.interest_periodicity
                        ? "Campo obrigatório"
                        : ""
                    }
                    onChange={(e) => handleSelect("interest_periodicity", e)}
                  />
                </div>

                <div style={{ position: "relative", top: "7px" }}>
                  <Input
                    name="amortization_grace_period"
                    id="amortization_grace_period"
                    maxLength={5}
                    max={5}
                    size="large"
                    label="Carência de amortização"
                    placeholder="Quantidade"
                    message={
                      showRequiredErrors && !values.amortization_grace_period
                        ? "Campo obrigatório"
                        : values.amortization_grace_period &&
                            values.duration &&
                            Number(values.amortization_grace_period) >=
                              Number(values.duration)
                          ? "A Carência de amortização não pode ser maior ou igual ao valor da Quantidade de amortizações"
                          : errorAmortizationPeriod
                            ? ` Informe um valor entre ${productDetails?.min_amortization_period}  e ${productDetails?.max_amortization_period}`
                            : ""
                    }
                    error={
                      (showRequiredErrors && !values.amortization_grace_period) ||
                      (values.amortization_grace_period &&
                        values.duration &&
                        Number(values.amortization_grace_period) >=
                          Number(values.duration)) ||
                      errorAmortizationPeriod
                    }
                    value={values.amortization_grace_period}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/[^0-9]/g, "");
                      setFieldValue("amortization_grace_period", value);
                    }}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <Input
                    name="interest_grace_period"
                    id="interest_grace_period"
                    maxLength={5}
                    max={5}
                    size="large"
                    label="Carência de juros"
                    placeholder="Quantidade"
                    value={values.interest_grace_period}
                    message={
                      showRequiredErrors && !values.interest_grace_period
                        ? "Campo obrigatório"
                        : values.interest_grace_period &&
                            values.duration &&
                            Number(values.interest_grace_period) >=
                              Number(values.duration)
                          ? "O valor da Carência de juros não pode ser maior ou igual ao valor da quantidade de amortizações"
                          : values.interest_grace_period &&
                              values.amortization_grace_period &&
                              Number(values.interest_grace_period) >
                                Number(values.amortization_grace_period)
                            ? "O valor da Carência de juros não pode ser maior do que o valor da Carência de amortização"
                            : ""
                    }
                    error={
                      (showRequiredErrors && !values.interest_grace_period) ||
                      (values.interest_grace_period &&
                        values.duration &&
                        Number(values.interest_grace_period) >=
                          Number(values.duration)) ||
                      (values.interest_grace_period &&
                        values.amortization_grace_period &&
                        Number(values.interest_grace_period) >
                          Number(values.amortization_grace_period))
                    }
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.replace(/[^0-9]/g, "");
                      setFieldValue("interest_grace_period", value);
                    }}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <InputSelect
                    name="calculation_base"
                    id="calculation_base"
                    kind="default"
                    size="small"
                    label="Base de cálculo"
                    options={calculationBaseOptions}
                    placeholder="Selecione uma opção"
                    error={showRequiredErrors && !values.calculation_base}
                    message={
                      showRequiredErrors && !values.calculation_base
                        ? "Campo obrigatório"
                        : ""
                    }
                    onChange={(e) => handleSelect("calculation_base", e)}
                  />
                </div>

                <div style={{ position: "relative", top: "7px" }}>
                  <Input
                    name="commission"
                    id="commission"
                    size="large"
                    error={errorCommission || values.commission === ""}
                    message={
                      showRequiredErrors && !values.commission
                        ? "Campo obrigatório"
                        : errorCommission || values.commission === ""
                          ? "Informe um valor entre 0 e 100"
                          : ""
                    }
                    maxLength={6}
                    max={6}
                    label="Correspondente bancário (%)"
                    placeholder="%"
                    value={values.commission}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d.]/g, "");
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        return;
                      }

                      setFieldValue("commission", value);
                    }}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <InputSelect
                    name="indexer"
                    id="indexer"
                    kind="default"
                    size="small"
                    label="Indexador pós-fixado"
                    options={indexesOptions}
                    placeholder="Selecione uma opção"
                    error={showRequiredErrors && !values.indexer}
                    message={
                      showRequiredErrors && !values.indexer
                        ? "Campo obrigatório"
                        : ""
                    }
                    onChange={(e) => handleSelect("indexer", e)}
                  />
                </div>
                <div style={{ position: "relative", top: "7px" }}>
                  <Input
                    name="indexer_rate"
                    id="indexer_rate"
                    size="large"
                    disabled={!values.indexer || values.indexer === "no_one"}
                    maxLength={6}
                    max={6}
                    value={values.indexer_rate}
                    label="Percentual indexador (%)"
                    placeholder="%"
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d.]/g, "");
                      const parts = value.split(".");
                      if (parts.length > 2) {
                        return;
                      }

                      setFieldValue("indexer_rate", value);
                    }}
                    error={
                      (values.indexer !== "no_one" &&
                        Number(values.indexer_rate) < 1) ||
                      (showRequiredErrors &&
                        values.indexer !== "no_one" &&
                        !values.indexer_rate)
                    }
                    message={
                      showRequiredErrors &&
                      values.indexer !== "no_one" &&
                      !values.indexer_rate
                        ? "Campo obrigatório"
                        : values.indexer !== "no_one" &&
                            Number(values.indexer_rate) < 1
                          ? "Digite um valor maior que 0"
                          : ""
                    }
                  />
                </div>
                {(values.indexer === "igpm" || values.indexer === "ipca") && (
                  <div style={{ position: "relative", top: "7px" }}>
                    <InputSelect
                      name="birthday_date_type"
                      id="birthday_date_type"
                      kind="default"
                      size="small"
                      label="Tipo da data de aniversário"
                      options={birthDateOptions}
                      placeholder="Selecione uma opção"
                      error={
                        showRequiredErrors &&
                        (values.indexer === "igpm" || values.indexer === "ipca") &&
                        !values.birthday_date_type
                      }
                      message={
                        showRequiredErrors &&
                        (values.indexer === "igpm" || values.indexer === "ipca") &&
                        !values.birthday_date_type
                          ? "Campo obrigatório"
                          : ""
                      }
                      onChange={(e) => handleSelect("birthday_date_type", e)}
                    />
                  </div>
                )}
                {(values.indexer === "igpm" || values.indexer === "ipca") &&
                  values.birthday_date_type === "fixed" && (
                    <div style={{ position: "relative", top: "7px" }}>
                      <Input
                        name="birthday_date_day"
                        id="birthday_date_day"
                        maxLength={5}
                        max={5}
                        size="large"
                        label="Dia da Data de Aniversário"
                        placeholder={"Digite"}
                        value={values.birthday_date_day}
                        error={
                          showRequiredErrors &&
                          values.birthday_date_type === "fixed" &&
                          (!values.birthday_date_day ||
                            values.birthday_date_day === "0")
                        }
                        message={
                          showRequiredErrors &&
                          values.birthday_date_type === "fixed" &&
                          (!values.birthday_date_day ||
                            values.birthday_date_day === "0")
                            ? "Campo obrigatório"
                            : ""
                        }
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^0-9]/g, "");

                          if (value === "") {
                            setFieldValue("birthday_date_day", "");
                            return;
                          }

                          let numValue = Number(value);
                          if (numValue > 31) numValue = 31;

                          setFieldValue(
                            "birthday_date_day",
                            numValue.toString()
                          );
                        }}
                      />
                    </div>
                  )}
              </div>
              <Margin mt={50} />

              {simulateResult?.calculation_type && (
                <div ref={printRef}>
                  {" "}
                  <h4>Resultados da simulação</h4>
                  <div
                    style={{
                      width: "100%",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                      gap: "32px",
                      rowGap: "30px",
                      marginTop: "20px",
                    }}
                  >
                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Data de emissão
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {simulateResult?.operation_date
                            ? format(
                                parseISO(simulateResult.operation_date),
                                "dd/MM/yyyy"
                              )
                            : "-"}
                        </p>
                      </div>
                    </Tile>
                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Data de vencimento
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {simulateResult?.due_date &&
                            format(
                              parseISO(simulateResult?.due_date),
                              "dd/MM/yyyy"
                            )}
                        </p>
                      </div>
                    </Tile>
                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Qtde. de amortizações
                        </h4>
                        <Margin mt={17} />
                        <p>{simulateResult?.duration}</p>
                      </div>
                    </Tile>

                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Valor do contrato
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {" "}
                          R${" "}
                          {formatNumberToCurrencyWithoutSimbol(
                            simulateResult?.requested_amount ?? 0
                          )}
                        </p>
                      </div>
                    </Tile>

                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Custo da emissão
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {" "}
                          R${" "}
                          {formatNumberToCurrencyWithoutSimbol(
                            simulateResult?.taxes_values?.emission_cost ?? 0
                          )}
                        </p>
                      </div>
                    </Tile>
                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Indexador
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {simulateResult?.taxes_settings?.indexer
                            ? indexesDict[
                                simulateResult?.taxes_settings?.indexer
                              ]
                            : "-"}
                        </p>
                      </div>
                    </Tile>
                    <Tile variations="default">
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Taxa A.M.
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {simulateResult?.taxes_settings.interest_rate_monthly?.toFixed(
                            4
                          )}{" "}
                          %
                        </p>
                      </div>
                    </Tile>
                    <Tile variations="default">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          padding: "10px 20px",
                        }}
                      >
                        <h4
                          style={{
                            fontWeight: "400",
                            fontFamily: "sans-serif",
                            fontSize: "18px",
                          }}
                        >
                          Taxa A.A.
                        </h4>
                        <Margin mt={17} />
                        <p>
                          {simulateResult?.taxes_settings.interest_rate_annually?.toFixed(
                            4
                          )}{" "}
                          %
                        </p>
                      </div>
                    </Tile>
                  </div>
                </div>
              )}
            </>
          )}

          <Margin mt={50} />
          {simulateResult?.calculation_type && (
            <div ref={printRef}>
              {" "}
              <Table
                pageSizes={[10, 5, 20, 50, 100]}
                columnTitles={titlesColumnInstallments}
                rowData={dataTableInstallments ?? []}
                width="1000px"
                radius
                // buttons={[
                //   {
                //     kind: "primary",
                //     position: "right",
                //     label: "Adicionar parcelas",
                //     icon: MoreIcon,
                //   },
                // ]}
              />
            </div>
          )}
        </>

        {!canDoSimulations && (
          <>
            <div>
              <Margin mt={70} />
              <TagLup src={lockIcon} />
              <Margin mt={30} />
              <Text>Acesso restrito</Text>

              <Subtext>
                Você não tem permissão para visualizar as simulações <br />{" "}
                contate o administrador do sistema para mais informações.
              </Subtext>
            </div>
          </>
        )}
      </div>
      {/* 
      <LateralModal
        toggleModal={() => null}
        open
        title="Novo"
        header
      ></LateralModal> */}

      <Modal
        height="600px"
        width="755px"
        background="#f7f4f4"
        onClose={handleCloseModal}
        label={
          <div>
            <h4>
              {" "}
              Simulação Nota Comercial{" "}
              {simulateResult?.uuid ? ` - ID: ${simulateResult.uuid}` : ""}
            </h4>
            <h4>Parcela {installmentData?.number}</h4>
          </div>
        }
        buttons={[
          {
            kind: "ghost",
            label: "Cancelar",
            onClick: handleCloseModal,
          },
          {
            kind: "primary",
            label: "Salvar",
            disabled:
              errorAmortizationInstallmentAmount ||
              errorDueDateInstallment ||
              errorInterestAmountInstallment ||
              errorDueDateToLongInstallment ||
              !values.due_date_installment,
            onClick: () => {
              sendUpdateInstallment();
            },
          },
        ]}
        open={editInstallment}
        radius
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(12, 1fr)",
            gap: "20px",
            padding: "20px",
          }}
        >
          <div style={{ gridColumn: "1 / -1" }}>
            <InputCurrency
              label="Valor para amortização"
              name="amortization_amount"
              id="amortization_amount"
              size="medium"
              error={errorAmortizationInstallmentAmount}
              message={
                errorAmortizationInstallmentAmount
                  ? `O valor para amortização não pode ser superior à R$ ${previousInstallment ? formatNumberToCurrencyWithoutSimbol(previousInstallment?.outstanding_amount) : ""}`
                  : ""
              }
              onChange={(e) =>
                setFieldValue("amortization_amount", e.target.value)
              }
              value={values.amortization_amount}
              disabled={
                Number(installmentData?.number) + 1 ===
                simulateResult?.installments?.length
              }
            />
          </div>

          <div style={{ gridColumn: "1 / -1", display: "flex", flexDirection: "row", gap: "10px", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <Input
                readOnly
                id="interest"
                label="Juros + indexador"
                size="large"
                type="text"
                placeholder={`R$ ${values.interest}`}
                onChange={(e) =>
                  setFieldValue("interest", e.target.value)
                }
              />
            </div>
            <div style={{marginLeft: "10px"}}></div>
            {convertStringCurrencyToNumber(values.original_interest) > 0 && (
              <div style={{ paddingTop: "28px" , width: "190px" }}>
                <Toggle 
                  id="interest_toggle" 
                  labelA="Ativar juros" 
                  labelB="Desativar juros"
                  toggled={values.interest_enabled}
                  onToggle={(toggled) => {
                    setFieldValue("interest_enabled", toggled);
                  }}
                />
              </div>
            )}
          </div>

          <div style={{ gridColumn: "span 6" }}>
            <Input
              name="due_date_installment"
              id="due_date_installment"
              size="large"
              type="date"
              error={errorDueDateInstallment || errorDueDateToLongInstallment}
              message={
                errorDueDateInstallment
                  ? `A data de vencimento não pode ser anterior à ${previousInstallment?.due_date ? format(parseISO(previousInstallment?.due_date), "dd/MM/yyyy") : ""}`
                  : errorDueDateToLongInstallment
                    ? `A data de vencimento não pode ser igual ou superior à ${simulateResult?.due_date ? format(parseISO(simulateResult?.due_date), "dd/MM/yyyy") : ""}`
                    : ""
              }
              label="Data de vencimento"
              onChange={(e) => {
                setFieldValue("due_date_installment", e.target.value);
              }}
              value={values.due_date_installment}
            />
          </div>

          <div style={{ gridColumn: "span 6" }}>
            <Input
              name="outstanding_amount"
              id="outstanding_amount"
              size="large"
              label="Saldo devedor"
              readOnly
              placeholder={`R$ ${formatNumberToCurrencyWithoutSimbol(
                values.outstanding_amount
              )}`}
              onChange={(e) =>
                setFieldValue("outstanding_amount", e.target.value)
              }
            />
          </div>
        </div>
      </Modal>
    </Container>
  );
};

export default SimulationCommercialNote;
